/**
 * 关联表（子表）的字段列表从哪来。
 *
 * 侧边栏里直接问 SDK。独立标签页的全屏编辑器没有 SDK —— 用户选了关联字段，
 * 属性栏卡在「正在读取关联表字段…」，明细表在主路径上根本配不了。所以侧边栏
 * 打开全屏前把每张关联表的字段先存进快照，这里优先从快照拿，拿不到再问 SDK。
 */
import { getFieldMetaList } from '../api/bitable';
import type { FieldMeta } from '../api/types';

let snapshot: Record<string, FieldMeta[]> | null = null;

/** 独立页启动时喂进来：tableId → 字段列表。 */
export function setLinkedMetaSnapshot(map: Record<string, FieldMeta[]> | null | undefined): void {
  snapshot = map && typeof map === 'object' ? map : null;
}

export async function loadFieldMetas(tableId: string): Promise<FieldMeta[]> {
  if (snapshot && snapshot[tableId]) return snapshot[tableId];
  return getFieldMetaList(tableId);
}

/** 关联字段类型：单向关联 / 双向关联。 */
export const LINK_FIELD_TYPES = [18, 21];

/** 从主表字段里挑出所有关联字段及它们指向的表。 */
export function linkTargets(fieldMetas: FieldMeta[]): Array<{ field: FieldMeta; tableId: string }> {
  const out: Array<{ field: FieldMeta; tableId: string }> = [];
  for (const f of fieldMetas) {
    if (!LINK_FIELD_TYPES.includes(f.type)) continue;
    const tableId = (f as unknown as { property?: { tableId?: string } }).property?.tableId;
    if (tableId) out.push({ field: f, tableId });
  }
  return out;
}
